"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
function Form({ children, onSubmit, id, onTrack, ...args }) {
    const refForm = (0, react_1.useRef)(null);
    const onSubmitEvent = (0, react_1.useCallback)((event) => {
        event.preventDefault && event?.preventDefault();
        event.stopPropagation && event?.stopPropagation();
        const payload = {};
        if (!!event?.nativeEvent?.submitter) {
            payload[event.nativeEvent.submitter.name] =
                event.nativeEvent.submitter.value;
        }
        for (let index = 0; index < event.target.length; index++) {
            const element = event.target[index];
            if (element.nodeName === "INPUT" ||
                element.nodeName === "SELECT" ||
                element.nodeName === "TEXTAREA") {
                if (element.required && !element.validity.valid) {
                    switch (element.nodeName) {
                        case "SELECT":
                            const selectEle = document.getElementById(`select-${element.id}`);
                            selectEle.scrollIntoView({
                                behavior: "smooth",
                                block: "center",
                            });
                            break;
                        case "INPUT":
                            if (element.type === "radio") {
                                const inputRadio = document.querySelector(`label[for='${element.id}']`);
                                inputRadio.scrollIntoView({
                                    behavior: "smooth",
                                    block: "center",
                                });
                            }
                            else {
                                const elementId = document.getElementById(`${element.id}`);
                                elementId.focus();
                            }
                            break;
                        default:
                            const elementId = document.getElementById(`${element.id}`);
                            elementId.focus();
                            break;
                    }
                    return;
                }
                switch (element.type) {
                    case "file":
                        payload[element.name] = element.files[0]
                            ? URL.createObjectURL(element.files[0])
                            : "";
                        break;
                    case "radio":
                        if (element.checked) {
                            payload[element.name] = element.value;
                        }
                        break;
                    case "checkbox":
                        if (element.checked) {
                            payload[element.name] = [
                                ...(payload?.[element.name] ?? []),
                                element.value,
                            ];
                        }
                        break;
                    case "select-multiple":
                        const selected = [];
                        for (let index = 0; index < element.selectedOptions.length; index++) {
                            const elementSelected = element.selectedOptions[index];
                            selected.push(elementSelected.value);
                        }
                        payload[element.name] = selected;
                        break;
                    // input[others], select-one,
                    default:
                        payload[element.name] = element.value;
                        break;
                }
            }
        }
        delete payload[""];
        // console.log(payload);
        onSubmit(payload);
    }, [onSubmit]);
    const fnTrack = (0, react_1.useCallback)((event) => {
        onTrack(event);
    }, [onTrack]);
    (0, react_1.useEffect)(() => {
        if (onTrack && id) {
            const form = refForm.current;
            if (form) {
                for (let index = 0; index < form.length; index++) {
                    const element = form[index];
                    if (element.name.includes("searchbar-select-multiple"))
                        continue;
                    if (element.nodeName === "INPUT" &&
                        (element.type === "checkbox" || element.type === "radio")) {
                        element.addEventListener("click", fnTrack, true);
                        continue;
                    }
                    if (element.nodeName === "INPUT" || element.nodeName === "TEXTAREA") {
                        element.addEventListener("blur", fnTrack, true);
                        continue;
                    }
                    if (element.nodeName === "SELECT") {
                        element.addEventListener("change", fnTrack, true);
                        continue;
                    }
                }
            }
        }
        return () => {
            if (onTrack && id) {
                const form = refForm.current;
                if (form) {
                    for (let index = 0; index < form.length; index++) {
                        const element = form[index];
                        if (element.name.includes("searchbar-select-multiple"))
                            continue;
                        if (element.nodeName === "INPUT" &&
                            (element.type === "checkbox" || element.type === "radio")) {
                            element.removeEventListener("click", fnTrack, true);
                            continue;
                        }
                        if (element.nodeName === "INPUT" ||
                            element.nodeName === "TEXTAREA") {
                            element.removeEventListener("blur", fnTrack, true);
                            continue;
                        }
                        if (element.nodeName === "SELECT") {
                            element.removeEventListener("change", fnTrack, true);
                            continue;
                        }
                    }
                }
            }
        };
    }, [onTrack, id]);
    return ((0, jsx_runtime_1.jsx)("form", { ...args, ref: refForm, noValidate: true, id: id, onSubmit: onSubmitEvent, children: children }));
}
exports.default = Form;
